<template>
  <div>
    <container-headline
      :headline="$t('global.companydetails') || 'Hofangaben'"
      :col="6"
    ></container-headline>

    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <!-- Felder für Gesch#ftspartner vom Typ Firma -->
          <div class="col-xl-12">
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <input
                      v-model.trim="firma.name"
                      class="form-control"
                      v-bind:class="{ 'border-danger': !passed }"
                      placeholder=" "
                      :readonly="!editable"
                    />
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.company") + " / " + $t("global.farmname")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <v-select
                      v-if="auswahlwerte.firma_partnerrollen"
                      v-model="firma.rollen"
                      label="bezeichnung"
                      :class="{ 'border-danger': !passed }"
                      :options="auswahlwerte.firma_partnerrollen"
                      :disabled="!editable"
                      placeholder="Typ"
                      :reduce="(r) => r.id"
                      multiple
                    >
                      <span slot="no-options">{{
                        $t("global.taptosearch")
                      }}</span>
                    </v-select>
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.type")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <v-select
                      v-model="firma.korrespondenzSprache"
                      v-bind:class="!passed ? 'border-danger' : ''"
                      :options="langs"
                      :disabled="!editable && !isAdmin"
                      :placeholder="$t('global.correspondencelanguage')"
                      :reduce="(r) => r.id"
                      label="bezeichnung"
                    >
                      <span slot="no-options">{{
                        $t("global.taptosearch")
                      }}</span>
                    </v-select>
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.correspondencelanguage")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <v-select
                    v-model="firma.status"
                    label="bezeichnung"
                    :options="auswahlwerte.aktivitaetsstati"
                    :reduce="(s) => s.id"
                    :disabled="!editable && !isAdmin"
                    :placeholder="$t('global.status')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.status") }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <v-select
                          v-model="firma.branche"
                          label="bezeichnung"
                          :options="auswahlwerte.branche"
                          :reduce="(b) => b.id"
                          :disabled="!editable && !isAdmin"
                          :placeholder="$t('global.dashboard_industry')"
                          :tabindex="3"
                        >
                          <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>
                        </v-select>
                        <label>{{ $t("global.dashboard_industry") }}</label>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label>
                    {{ $t("global.pictures") }}
                  </label>
                  <div
                    class="file-upload"
                    @click="triggerFileUpload"
                    :title="selectedFiles ? selectedFilesFormattedTooltip : ''"
                  >
                    {{
                      selectedFiles
                        ? selectedFilesFormatted
                        : $t("global.selectfiles")
                    }}
                    <input
                      type="file"
                      ref="bild"
                      :readonly="!editable"
                      hidden
                      @change="handleFileChange"
                      accept="image/*"
                      multiple
                    />
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";
import { LADE_AUSWAHLWERTE_EINSTELLUNGEN } from "@/store/einstellungendashboard/actions.type";

export default {
  name: "FirmenangabenNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    firma: {
      type: Object,
      default: function () {
        return {};
      },
    },
    editable: {
      type: Boolean,
      required: true,
    },
    auswahlwerte: {
      type: Object,
    },
  },
  data() {
    return {
      isAdmin: false,
      selectedFiles: null,
    };
  },
  computed: {
    langs: {
      get() {
        return this.$store.state.einstellungendashboard.sprachen.filter(
          s => s.id !== '1978DF9D963'
        );
      },
    },
    selectedFilesFormatted() {
      let selectedFilesFormatted = "";
      this.selectedFiles.forEach((file, index) => {
        selectedFilesFormatted += (index > 0 ? ", " : "") + file.name;
      });
      return selectedFilesFormatted;
    },
    selectedFilesFormattedTooltip() {
      let selectedFilesFormatted = "";
      this.selectedFiles.forEach((file, index) => {
        selectedFilesFormatted += (index > 0 ? "\n" : "") + file.name;
      });
      return selectedFilesFormatted;
    },
  },
  created() {},
  watch: {
    ["firma.rolle"]: {
      handler: function (val) {
        if (val && this.auswahlwerte.firma_partnerrollen.length > 0) {
          this.$emit("rolesChanged", val);
        }
      },
      immediate: true,
    },
  },
  mounted: function () {
    this.isAdmin =
      this.gruppen.findIndex(
        (gruppe) => gruppe.id == this.$CONST("GRUPPEN").ADMIN
      ) == -1
        ? false
        : true;

    if (this.langs.length == 0) {
      this.$store.dispatch(
        `einstellungendashboard/${LADE_AUSWAHLWERTE_EINSTELLUNGEN}`
      );
    }
  },
  methods: {
    triggerFileUpload() {
      if (this.$refs.bild) {
        this.$refs.bild.click();
      }
    },

    handleFileChange(event) {
      this.selectedFiles = Array.from(event.target.files);
    },
  },
};
</script>

<style></style>
